export enum VisibilityStatus {
    HIDDEN = 0,
    REQUEST_SENT = 1,
    VISIBLE = 2,
    DELETED = 3
}
